import { useEffect, useRef, useState } from "react";
import {
  StaffListConstants,
} from "../../constants/constants";
import PersonalInformationDynamic from "./PersonalInformationDynamic";
import EditIconForEditFLow from "../../assets/images/EditIconForEditFLow";
const tableHeaderStyle = "text-black staffListHeader font-nunito ";
const tableDataStyle = "text-center quickLinksDescription text-black py-2";
const EducationalDetailsTable = ({
  userDetail,
  handleEditEducationalInformation,
  editModeForEducationalDetails,
  educationalDetailsIndex,
  order,
  addMoreEducationalInfo,
  setEditPayloadjson,
  jsonForEditData,
  isEditMode = false,
  showEducationTableInEditFlow,
  setIsSaveButtonClicked,
  isSaveButtonCLicked,
  errors,
  setErrors,
  educationalIndexRef,
  addMoreEducationEditRef,
  // activeEducationIndex = undefined,
}: {
  userDetail: any;
  handleEditEducationalInformation: any;
  editModeForEducationalDetails: any;
  educationalDetailsIndex: any;
  order: any;
  addMoreEducationalInfo: any;
  setEditPayloadjson: any;
  jsonForEditData: any;
  isEditMode?: any;
  showEducationTableInEditFlow?: any;
  setIsSaveButtonClicked?: any;
  isSaveButtonCLicked?: any;
  errors?: any;
  setErrors?: any;
  educationalIndexRef?: any;
  addMoreEducationEditRef?: any;
  // activeEducationIndex?: number | undefined;
}) => {
  let educationInfo: any[] = [];
  if (isEditMode) {
    educationInfo = userDetail[order]?.subSegments.filter(
      (item: { name: string }) => item.name === "Educational Information"
    );
  } else {
    educationInfo = userDetail;
  }


  // const [refreshFlag, setRefreshFlag] = useState(false);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setRefreshFlag(prev => !prev); // Toggle flag to trigger refresh
  //     console.log("Refreshing data..........................................");
  //   }, 5000); // Refresh every 5 seconds (adjust as needed)
    
  //   return () => clearInterval(interval); // Cleanup on unmount
  // }, []);
  const [activeEducationIndex, setActiveEducationIndex] = useState(educationalIndexRef);

  useEffect(() => {
    if( !addMoreEducationEditRef) {
    if (activeEducationIndex) {
      const newJson = educationdetailforedit();
      setJsonForEdit(newJson);
      setTempFlag(false);
    }
  }
  }, [addMoreEducationalInfo, userDetail, jsonForEditData, activeEducationIndex]);



// Sync the ref and state — whenever ref changes, update state
useEffect(() => {
  setActiveEducationIndex(educationalIndexRef);
}, [educationalIndexRef]);
  const educationdetailforedit = () => {
    return {
      segmentId: userDetail[order]?.segmentId,
      name: userDetail[order]?.name,
      description: userDetail[order]?.description,
      segmentOrder: userDetail[order]?.segmentOrder,
      subSegments: [
        addMoreEducationalInfo
          ? addMoreEducationalInfoForEdit()
          : educationInfo[activeEducationIndex] ,
          // educationalDetailsIndex
      ],
    };
  };
  const addMoreEducationalInfoForEdit = () => {
    if (jsonForEditData) {
      const firstEducationalInfo = addMoreEducationalInfo
        ? jsonForEditData?.formSegments[order]?.subSegments.find(
            (subSegment: any) => subSegment.name === "Educational Information"
          )
        : userDetail[order]?.subSegments.find(
            (subSegment: any) => subSegment.name === "Educational Information"
          );
      const clearedEducationalInfo = JSON.parse(
        JSON.stringify(firstEducationalInfo)
      );
      clearedEducationalInfo?.attributes?.forEach((attr: any) => {
        attr.value = ""; 
      });
      return clearedEducationalInfo;
    }
  };
  useEffect(() => {
    if (addMoreEducationalInfo) {
      if(!removeEmptyEducationalInfo(jsonForEditData?.formSegments[order])){
 jsonForEditData?.formSegments[order]?.subSegments.push(
        addMoreEducationalInfoForEdit()
      );
      }
    }
  }, [addMoreEducationalInfo]);



  const removeEmptyEducationalInfo = (formSegment: any) => {
    const educationalInfos = formSegment.subSegments.filter(
      (sub: any) => sub.name === "Educational Information"
    );
  
    const lastEducationalInfo = educationalInfos[educationalInfos.length - 1];
  
    const areAllAttributesEmpty = (subSegment: any): boolean => {
      return subSegment?.attributes?.every(
        (attr: any) =>
          attr.value === "" || attr.value === null || attr.value === undefined
      );
    };
    
    return areAllAttributesEmpty(lastEducationalInfo);
  };
   
  const [jsonForEdit, setJsonForEdit] = useState<any>();
  const [tempFlag, setTempFlag] = useState<boolean>(true);



  useEffect(() => {
    setJsonForEdit(educationdetailforedit());
  }, []);


  useEffect(() => {
    if ((addMoreEducationalInfo && tempFlag) || showEducationTableInEditFlow ) {
      setJsonForEdit(educationdetailforedit());
      setTempFlag(false);
    }
  }, [addMoreEducationalInfo, userDetail, jsonForEditData]);
  return (
    <>
      <div className="block lg:hidden">
        <div className="">
          <div>
            {editModeForEducationalDetails ? (
              <div>
                <PersonalInformationDynamic
                  jsonObjForEdit={
                    addMoreEducationalInfo ? jsonForEditData : [userDetail]
                  }
                  jsonobj={[jsonForEdit]} // Wrap the returned object in an array
                  order={0}
                  isEditMode={true}
                  indexOfValueToBeModified={educationalDetailsIndex}
                  // educationalDetailsIndex
                  setEditPayloadjson={setEditPayloadjson}
                  addMoreEducationalInfo={addMoreEducationalInfo}
                  addmoreEducationOrder={order}
                  setJsonForEditFlow={setJsonForEdit}
                  showEducationTableInEditFlow={showEducationTableInEditFlow}
                  isSaveButtonCLicked={isSaveButtonCLicked}
                  setIsSaveButtonClicked={setIsSaveButtonClicked}
                  errors={errors}
                  setErrors={setErrors}
                />
              </div>
            ) : (
              <div className="flex flex-col ">
                {educationInfo?.map((item: any, index: number) => {
               

                  const attributes = item?.attributes?.reduce(
                    (acc: any, attr: any) => {
                      acc[attr?.name] = attr?.value;
                      return acc;
                    },
                    {}
                  );

                  return (
                    <div
                      key={index}
                      className="bg-white shadow-md rounded-xl p-4  cursor-pointer hover:shadow-lg border border-gray-300"
                    >
                      <div className="flex justify-between items-start  gap-4">
                        <div>
                          <div className="font-nunitolabelText label label  text-label text-black">
                            {StaffListConstants.qualification}
                          </div>
                          <div className="text-black employeeId mb-3">
                            {attributes["degreeName"]}
                          </div>
                        </div>

                        <div>
                          <div className="font-nunitolabelText label  text-label text-black">
                            {StaffListConstants.grade}
                          </div>
                          <div className="text-black employeeId mb-3">
                            {attributes["percentage"]}
                          </div>
                        </div>
                        <div>
                          <div className="font-nunitolabelText label  text-label text-black">
                            {StaffListConstants.yearOfPassing}
                          </div>
                          <div className="text-black employeeId mb-3">
                            {attributes["yearOfPassing"]}
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-between items-start gap-4">
                        <div>
                          <div className="font-nunito  label  text-label text-black">
                            {StaffListConstants.nameOfInsitute}
                          </div>
                          <div className="text-black employeeId mb-3">
                            {attributes["university"]}
                          </div>
                        </div>
                        <div>
                          <div className="font-nunito  label  text-label  text-black">
                            {StaffListConstants.EducationBoard}
                          </div>
                          <div className="text-black employeeId mb-3">
                            {attributes["educationBoard"]}
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-end items-center ">
                        <div
                          className="flex items-center gap-3 "
                          onClick={() => {
                            console.log("object");
                            handleEditEducationalInformation(index);
                          }}
                        >
                          <EditIconForEditFLow height="24px" width="24px" />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="hidden lg:block">
        <div>
          {editModeForEducationalDetails ? (
            <div>
              <PersonalInformationDynamic
                jsonObjForEdit={
                  addMoreEducationalInfo ? jsonForEditData : [userDetail]
                }
                jsonobj={[jsonForEdit]} // Wrap the returned object in an array
                order={0}
                isEditMode={true}
                indexOfValueToBeModified={educationalDetailsIndex}
                // educationalDetailsIndex
                setEditPayloadjson={setEditPayloadjson}
                addMoreEducationalInfo={addMoreEducationalInfo}
                addmoreEducationOrder={order}
                setJsonForEditFlow={setJsonForEdit}
                showEducationTableInEditFlow={showEducationTableInEditFlow}
                isSaveButtonCLicked={isSaveButtonCLicked}
                setIsSaveButtonClicked={setIsSaveButtonClicked}
                errors={errors}
                setErrors={setErrors}
              />
            </div>
          ) : (
            <div>
              <table className="w-full  my-8 border-collapse border border-gray-300">
                <thead className="bg-sideMenubackground h-[64px]">
                  <tr>
                    <th className={`pl-8 ${tableHeaderStyle}`}>
                      {StaffListConstants.qualification}
                    </th>
                    <th className={tableHeaderStyle}>
                      {StaffListConstants.nameOfInsitute}
                    </th>
                    <th className={tableHeaderStyle}>
                      {StaffListConstants.grade}
                    </th>
                    <th className={tableHeaderStyle}>
                      {StaffListConstants.yearOfPassing}
                    </th>
                    <th className={tableHeaderStyle}>
                      {StaffListConstants.EducationBoard}
                    </th>
                    <th className={`pr-8 ${tableHeaderStyle}`}>
                      {StaffListConstants.Action}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {educationInfo?.map((item: any, index: number) => {
                    if (
                      item.name !== "Educational Information" &&
                      !editModeForEducationalDetails
                    ) {
                      return null; // Skip rendering this item
                    }
                    const attributes = item.attributes.reduce(
                      (acc: any, attr: any) => {
                        acc[attr.name] = attr.value;
                        return acc;
                      },
                      {}
                    );

                    return (
                      <tr className="border-b " key={index}>
                        {/* Qualification */}
                        <td className={tableDataStyle}>
                          {attributes["degreeName"]}
                        </td>
                        {/* Institute Name */}
                        <td className={tableDataStyle}>
                          {attributes["university"]}
                        </td>
                        {/* Grade */}
                        <td className={tableDataStyle}>
                          {attributes["percentage"]}
                        </td>
                        {/* Year of Passing */}
                        <td className={tableDataStyle}>
                          {attributes["yearOfPassing"]}
                        </td>
                        {/* Education Board */}
                        <td className={tableDataStyle}>
                          {attributes["educationBoard"]}
                        </td>
                        {/* Action */}
                        <td
                          className={tableDataStyle}
                          onClick={() => {
                            handleEditEducationalInformation(index);
                          }}
                        >
                          <EditIconForEditFLow />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default EducationalDetailsTable;
